<template>
  <div>
    <a-table :columns="columns" :data-source="datavalue" rowKey="id" :pagination="pagination" @change="changePagination">
      <span slot="status" slot-scope="text">
        <span v-if="text==0">等待处理</span>
        <span v-else-if="text==1">正在处理</span>
        <span v-else>完成处理</span>
      </span>
      <span slot="progress" slot-scope="text,record">
        {{ record.status==2?'':record.progress }}
      </span>
    </a-table>
  </div>
</template>

<script>
const columns = [
  // {
  //   title: "编号",
  //   dataIndex: "id",
  //   key: "id",
  // },
  {
    title: "任务",
    dataIndex: "taskName",
    key: "task",
  },
  {
    title: "进度",
    key: "progress",
    dataIndex: "progress",
    slots: { title: "progress" },
    scopedSlots: { customRender: "progress" },
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
    slots: { title: "status" },
    scopedSlots: { customRender: "status" }
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
  }
];
export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      datavalue:this.data,
      columns,
      paginationvalue:{},
      pagination: {
        total:this.total
      }
    };
  },
  methods: {
    changePagination(value){
      this.$emit('changepage',value.current)
    }
  },
  watch: {
    data(nev,oldv){
      this.datavalue = nev
    }
  }
};
</script>

<style>
</style>